/** @typedef {'product' | 'cart'} BnplPageType */

export const BNPL_PAGE_TYPE = Object.freeze({
  PRODUCT: 'product',
  CART: 'cart',
});

export const ZIP_WIDGET_ASSET = Object.freeze({
  PRODUCT: 'productwidget',
  CART: 'cartwidget',
});

/** Matches theme breakpoints.lg (992px) — mobile base, desktop lg+. */
export const BNPL_BREAKPOINT_LG = '992px';

const bnplSize = Object.freeze({base: '12px', lg: '13px'});

/** Shared logo / info-icon sizing for Afterpay + Zip widgets (desktop + mobile). */
export const BNPL_WIDGET_STYLE = Object.freeze({
  AFTERPAY_LOGO_BADGE_WIDTH: '70px',
  AFTERPAY_LOGO_BADGE_INCLUDE_TEXT_WIDTH: '82px',
  FONT_SIZE: bnplSize,
  INFO_ICON_SIZE: bnplSize,
  LOGO_HEIGHT: Object.freeze({base: '24px', lg: '24px'}),
});

/** Afterpay shadow DOM ignores @media — pass viewport-derived sizes from matchMedia instead. */
export const buildAfterpayShadowStyles = (isDesktop = false) => {
  const logoHeight = isDesktop ? BNPL_WIDGET_STYLE.LOGO_HEIGHT.lg : BNPL_WIDGET_STYLE.LOGO_HEIGHT.base;
  const infoIconSize = isDesktop ?
    BNPL_WIDGET_STYLE.INFO_ICON_SIZE.lg :
    BNPL_WIDGET_STYLE.INFO_ICON_SIZE.base;
  const includeTextBadgeWidth = BNPL_WIDGET_STYLE.AFTERPAY_LOGO_BADGE_INCLUDE_TEXT_WIDTH;
  const logoBadgeWithTextWidth = `var(--logo-badge-width, ${includeTextBadgeWidth})`;
  const logoHeightRatio = Number.parseFloat(logoHeight) / Number.parseFloat(includeTextBadgeWidth);

  return `
    #logo-link {
      font-size: ${infoIconSize} !important;
      height: ${logoHeight} !important;
      line-height: 1 !important;
      min-height: ${logoHeight} !important;
      min-width: ${infoIconSize} !important;
      vertical-align: middle !important;
    }

    #logo-link svg,
    button.afterpay-logo svg {
      height: ${logoHeight} !important;
      width: auto !important;
    }

    #info-link {
      font-size: ${infoIconSize} !important;
      line-height: 1 !important;
      vertical-align: middle !important;
    }

    .afterpay-logo.brand-afterpay.logo-cashappafterpay {
      max-width: ${logoBadgeWithTextWidth} !important;
      height: calc(${logoBadgeWithTextWidth} * ${logoHeightRatio}) !important;
    }
    .afterpay-logo.brand-afterpay.logo-cashappafterpay svg {
      max-width: 100% !important;
    }
  `;
};

export const BNPL_DEFAULTS = Object.freeze({
  AFTERPAY_SCRIPT_URL: 'https://js.squarecdn.com/square-marketplace.js',
  AFTERPAY_MIN_AMOUNT: '1',
  AFTERPAY_MAX_AMOUNT: '4000.00',
  AFTERPAY_PLATFORM: 'SFCC',
  ZIP_SCRIPT_URL: 'https://static.zip.co/lib/js/zm-widget-js/dist/zip-widget.min.js',
  ZIP_ENVIRONMENT: 'production',
});

export const BNPL_PREFERENCE_KEYS = Object.freeze({
  AFTERPAY_ENABLED: 'AFTERPAY_ENABLED',
  AFTERPAY_MPID: 'AFTERPAY_MPID',
  AFTERPAY_SCRIPT_URL: 'AFTERPAY_SCRIPT_URL',
  AFTERPAY_MIN_AMOUNT: 'AFTERPAY_MIN_AMOUNT',
  AFTERPAY_MAX_AMOUNT: 'AFTERPAY_MAX_AMOUNT',
  AFTERPAY_PLATFORM: 'AFTERPAY_PLATFORM',
  ZIP_ENABLED: 'ZIP_ENABLED',
  ZIP_MERCHANT_KEY: 'ZIP_MERCHANT_KEY',
  ZIP_ENVIRONMENT: 'ZIP_ENVIRONMENT',
  ZIP_SCRIPT_URL: 'ZIP_SCRIPT_URL',
});
